<div class="container-fluid m-0 p-0" *ngIf="!showLoader">
    <form [formGroup]="editFmMember" (change)="editFmMemberChange()" (submit)="editFmMemberSubmit()">
        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{ "EDIT_FM_Member" | translate | titlecase }}</h6>
            </div>
            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                <button type="button" class="btn btn-outline-secondary m-2 rounded-0" routerLink="/admission/family-members"
                    *ngIf="!updating">
                    {{ "CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!updating"><i
                        class="fas fa-save"></i>
                    {{ "SAVE" | translate | titlecase }}</button>
                <app-loader [show]="updating"></app-loader>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-12">
                <div class="row bg-white border m-0 py-3 ">
                    <div class="col-md-10 mx-md-auto pt-md-5 px-md-5">
                        <div class="row">
                            <div class="col-md-6 align-self-end">
                                <label class="font-bold">{{ "FAMILY_MEMBER_AR" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="memberNameAr">
                                <div class="alert alert-danger px-3 p-1 mt-1"
                                    *ngIf="editFmMember.controls.memberNameAr.touched && editFmMember.controls.memberNameAr.invalid && editFmMember.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 align-self-end">
                                <label class="font-bold">{{ "FAMILY_MEMBER_EN" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="memberNameEn">
                                <div class="alert alert-danger px-3 p-1 mt-1"
                                    *ngIf="editFmMember.controls.memberNameEn.touched && editFmMember.controls.memberNameEn.invalid && editFmMember.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 align-self-end">
                                <label class="font-bold">{{ "ORDER_NUMBER" | translate | titlecase }}</label>
                                <input type="number" class="form-control" formControlName="orderNo">
                                <div class="alert alert-danger px-3 p-1 mt-1"
                                    *ngIf="editFmMember.controls.orderNo.touched && editFmMember.controls.orderNo.invalid && editFmMember.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<app-loader [show]="showLoader"></app-loader>
